module.exports = __webpack_public_path__ + "img/bg_pic1.419c8df8.png";